// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evaluation-main-actions {
  margin: 32px 0 64px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  color: #717680;
  font-size: 13px;
  line-height: 20px;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/Evaluation/EvaluationMainActions/index.less"],"names":[],"mappings":"AAGA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ACFJ;AACA,oCAAoC","sourcesContent":["@import \"../../../less/variables.less\";\n@import (reference) \"../../core/foundations/spacing/spacing.less\";\n\n.evaluation-main-actions {\n    margin: (@spacing-unit * 8) 0 (@spacing-unit * 16);\n    display: flex;\n    flex-direction: column;\n    gap: (@spacing-unit * 4);\n    align-items: center;\n    color: @fg-quaternary;\n    font-size: 13px;\n    line-height: 20px;\n}\n",".evaluation-main-actions {\n  margin: 32px 0 64px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  color: #717680;\n  font-size: 13px;\n  line-height: 20px;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
